import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { PackageScanModesFormDataProviderFactory } from '../factory/PackageScanModesFormDataProviderFactory';
import { PackageScanModesFormBaseDataProvider } from '../dataProvider/PackageScanModesFormBaseDataProvider';
import { ScanModeData } from '../types/ScanModeData';

export class PackageScanModesFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PackageScanModesFormDataProviderFactory;
  public dataProvider: PackageScanModesFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PackageScanModesFormDataProviderFactory(),
    });
  }

  public getScanModes(): ScanModeData[] {
    return this.dataProvider.getScanModes();
  }

  public getSimpleScanModes(): ScanModeData[] {
    return this.dataProvider.getSimpleScanModes();
  }

  public getEc2ScanModes(): ScanModeData[] {
    return this.dataProvider.getEc2ScanModes();
  }
}
